import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
* {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  box-sizing:border-box;
  -webkit-tap-highlight-color: transparent;
}

body {
  font-family: "Pretendard";
  font-size: 16px;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}

abbr[title] {
  text-decoration: none;
}
  
nav, section {
  display: block;
}

ol, ul {
  list-style: none;
}


a {
  display: inline-block;
  text-decoration: none;
  color: initial;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}


input, textarea, button {
  outline: none;
  font-family: inherit; 
}

button {
  line-height: 1;
}

textarea {
  resize:none;
}



h1 {
  display:none;
}



`;

// &::-webkit-scrollbar {
//   -webkit-appearance: none;
//   width: 4px;
//   height: 4px;
// }

// &::-webkit-scrollbar-thumb {
//   background-color: ${({ theme }) => theme.colors.scroll};
//   border-radius: 10px;
// }

// &::-webkit-scrollbar-track:horizontal {
//   background-color: ${({ theme }) => theme.colors.gray100};
// }

// &::-webkit-scrollbar-track:vertical {
//   background-color: transparent;
// }
